import React from "react";


export default class Body extends React.Component {
    render() {
        return (
           <div> {this.props.children} </div>
        )
    }
}